import { Button } from '../uiLib'

function getResponseMessage({ request_sent, code_data }, t) {
  if (code_data === 'SUCCESSFUL') {    
    return t('common:security-code-response')
  } else {
    return 'An error occurred: ' + code_data
  }
}


export default ({ securityCode, handleResetForm, t }) => (
  <div>
    <p className="m-b-md">{ getResponseMessage(securityCode, t) }</p>
    <Button
      outlined
      btType="default"
      className="is-default"
      onClick={handleResetForm}
    >
      {t('common:send-new-request')}
    </Button>
  </div>
)



// WEBPACK FOOTER //
// ./components/PATSCodes/SecurityCodeRequestStatus.js